import { ActionTypes } from "../constants/action-types";


// const INITIAL_STATE = {
//     featured: [],
//     main: [],
//     watchlist: []
// }

const initialFeaturedState = {
    featured: [],
}

const initialMainState = {
    main: [],
}

const initialWatchlistState = {
    watchlist: [],
}

export const selectedMovieReducer = (state = {}, action) => {
    switch (action.type) {
        case ActionTypes.SELECTED_MOVIE:
            return {...state, ...action.payload};
        case ActionTypes.REMOVE_SELECTED_MOVIE:
            return {};

        default:
            return state;
    }
}

export const featuredMovieReducer = (state = initialFeaturedState, action) => {
    switch (action.type) {
        case ActionTypes.SET_FEATURED_MOVIES:
            // return {...state, featured: action.payload};
            return {...state, featured: action.payload.map(payload => ({...payload, badge: false}))};
        // case ActionTypes.BADGE_TRUE: 
        //     const badgeIndex = state.featured.findIndex(featuredMov => featuredMov.id === action.payload.id)
        //     state.featured[badgeIndex].badge = true
                
        default:
            return state;
    }
}

export const mainMovieReducer = (state = initialMainState, action) => {
    switch (action.type) {
        case ActionTypes.SET_MAIN_MOVIES:
            return {...state, main: action.payload.map(payload => ({...payload, badge: false}))};
        default:
            return state;
    }
}

export const heroMovieReducer  = (state = {}, action) => {
    switch (action.type) {
        case ActionTypes.SET_HERO_MOVIE:
                return {...state, ...action.payload, badge: false}
        default:
            return state;
    }
}

export const watchlistReducer = (state = initialWatchlistState, action) => {
    switch (action.type) {
        case ActionTypes.ADD_TO_WATCHLIST:
            const index = state.watchlist.findIndex(element => element.id === action.payload.id);
            if(index === -1) {
                // return {...state, watchlist: [...state.watchlist, {...action.payload, badge: true}]}
                return {...state, watchlist: [...state.watchlist, action.payload]}
            } else {
                return {...state, watchlist: [...state.watchlist]}
            }
        case ActionTypes.REMOVE_FROM_WATCHLIST:
            return {...state, watchlist: state.watchlist.filter(watchlistItem =>
                watchlistItem.id !== action.payload.id
            )}    
        default: 
            return state;
    }
}

// export const badgeReducer = (state = [], action) => {
//     switch (action.type) {
//         case ActionTypes.BADGE_TRUE:
//             return {...state, featured: [...state.featured, {...action.payload, badge: true}]}
    
//         default:
//             return state;
//     }
// }